module.exports = __webpack_public_path__ + "static/media/disclaimer.faa07c36.png";